import React from "react";
import { Form, Input, Button, Card, DatePicker } from "antd";
import dayjs from "dayjs";
import { editCandidate } from "api/candidate.api";
import { useDispatch } from "react-redux";
import { creditsRefreshChanger } from "store/slices/refresh.slice";

interface CandidateAddEducationFormProps {
    setIsAddEducation: React.Dispatch<React.SetStateAction<boolean>>;
    candidateId: number;
    setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
    loading: boolean;
    setError: React.Dispatch<React.SetStateAction<string | null>>;
    editorName: string;
}

const CandidateAddEducationForm: React.FC<CandidateAddEducationFormProps> = ({ setIsAddEducation, setRefresh, setError, editorName, candidateId }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    const handleAddEducation = async () => {
        const startDate = form.getFieldValue("start_date");
        const endDate = form.getFieldValue("end_date");

        const formatDate = (dateString: string): string => {
            const date = new Date(dateString);
            return date.toLocaleString("en-US", { month: "short", year: "numeric" });
        };

        const candidateEducationPayload = {
            custom_fields: {
                education_experience: [{
                    education_experience: [
                        {
                            schoolName: form.getFieldValue("schoolName"),
                            degree: form.getFieldValue("degree"),
                            field: form.getFieldValue("field"),
                            start_date: startDate ? startDate.format("YYYY-MM-DD") : null,
                            start_date_formatted: startDate ? formatDate(startDate.format("YYYY-MM-DD")) : null,
                            end_date: endDate ? endDate.format("YYYY-MM-DD") : null,
                            end_end_date_formatteddate: endDate ? formatDate(endDate.format("YYYY-MM-DD")) : null,
                            description: form.getFieldValue("description"),
                            logo_url: form.getFieldValue("logo_url"),
                            is_edited: false,
                            edited_by: editorName,
                            modified_date: new Date(),
                        }
                    ]
                }], edited_by: editorName, modified_date: new Date(), is_edited: false
            }, candidate: candidateId
        };
        console.log("Education Payload:", candidateEducationPayload);
        try {
            const data = await editCandidate(candidateEducationPayload);
            setRefresh(true);
            setIsAddEducation(false);
        } catch (err) {
            setError("Failed to update candidate description");
        } finally {
            // setRefresh(false);
            dispatch(creditsRefreshChanger());
        }
    };

    const onFinish = (values: any) => {
        console.log("Form Submitted: ", values);
        handleAddEducation();
        setIsAddEducation(false);
    };

    return (
        <Card title="Education Details Form" style={{ maxWidth: "100%", margin: "auto" }}>
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                requiredMark={false}
            // initialValues={{
            //     schoolName: "GLS University",
            //     degree: "Mscit",
            //     field: "Mobile technology",
            //     start_date: dayjs("2020-01-01"),
            //     end_date: dayjs("2022-03-31"),
            //     description: "",
            //     logo_url: "",
            // }}
            >
                <Form.Item label={<span>School Name<span style={{ color: "red" }}>*</span></span>} name="schoolName" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>

                <Form.Item label={<span>Degree<span style={{ color: "red" }}>*</span></span>} name="degree" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>

                <Form.Item label={<span>Field of Study<span style={{ color: "red" }}>*</span></span>} name="field" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>

                <Form.Item label={<span>Start Date<span style={{ color: "red" }}>*</span></span>} name="start_date" rules={[{ required: true }]}>
                    <DatePicker format="MMM, YYYY" picker="month" style={{ width: "100%" }} />
                </Form.Item>

                <Form.Item label={<span>End Date<span style={{ color: "red" }}>*</span></span>} name="end_date" rules={[{ required: true }]}>
                    <DatePicker format="MMM, YYYY" picker="month" style={{ width: "100%" }} />
                </Form.Item>

                <Form.Item label="Description" name="description">
                    <Input.TextArea rows={3} />
                </Form.Item>

                <Form.Item label="Logo URL" name="logo_url">
                    <Input />
                </Form.Item>

                <Form.Item>
                    <Button className="relative font-semibold text-sm text-white py-2 px-3 bg-[#845dda] border border-[#7F56D9] flex gap-1 rounded-lg group" htmlType="submit">Submit</Button>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default CandidateAddEducationForm;
